module.exports = [{
      plugin: require('../node_modules/gatsby-remark-images/gatsby-browser.js'),
      options: {"plugins":[],"maxWidth":1100,"linkImagesToOriginal":false},
    },{
      plugin: require('../node_modules/gatsby-plugin-breadcrumb/gatsby-browser.js'),
      options: {"plugins":[],"useAutoGen":true,"exclude":["/dev-404-page/","/404/","/404.html","/offline-plugin-app-shell-fallback/"],"crumbLabelUpdates":[{"pathname":"/about","crumbLabel":"About Aradhna"},{"pathname":"/about/honors-and-awards","crumbLabel":"Honors & Awards"},{"pathname":"/about/keynotes-and-lectures","crumbLabel":"Keynotes & Lectures"},{"pathname":"/lab","crumbLabel":"The Lab"},{"pathname":"/lab/alumni","crumbLabel":"Lab Alumni"},{"pathname":"/engagement/community-and-policy","crumbLabel":"Community & Policy"},{"pathname":"/diversity-center","crumbLabel":"Center for Diverse Leadership in Science"}]},
    },{
      plugin: require('../node_modules/gatsby-plugin-netlify-cms/gatsby-browser.js'),
      options: {"plugins":[],"modulePath":"/opt/build/repo/src/cms/cms.js","htmlFavicon":"/opt/build/repo/src/images/favicon-32.png"},
    },{
      plugin: require('../node_modules/gatsby-plugin-catch-links/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
